import React from 'react'
import { usePartner } from '@@partner:helpers/hooks/auth'

import { generatePath } from 'react-router-dom'
import LegacyPlusIcon from '@rsuite/icons/legacy/Plus'
import StoriesGrid from '@components/marketing/stories/StoriesGrid'

import { ROUTE_MARKETING_STORIES_ADD } from '@@partner:config/routes'
import CommonSubTopMenu from '@components/common/subTopMenu/CommonSubTopMenu'

export default function StoriesPage () {
  const { brandSlug } = usePartner()

  return (
    <div>
      <StoriesGrid brandSlug={brandSlug} />
    </div>
  )
}
